import {Ventrata} from 'types'
import {CartItems} from './Left/Left'
import {Right} from './Right/Right'
import {ConfirmationPageSubtitle} from './widgets/ConfirmationPageSubtitle'

type Props = {
  order: Ventrata.Order
}

export const ThankYou = ({order}: Props) => {
  return (
    <div className="flex flex-col gap-8">
      <div className="font-bold text-[32px]">Thanks for booking with us!</div>
      <div>
        <ConfirmationPageSubtitle order={order} />
      </div>
      <div className="font-bold text-2xl">Order summary</div>

      <div className="flex flex-col d:flex-row justify-between">
        <CartItems order={order} />
        <Right order={order} />
      </div>
    </div>
  )
}
